import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { catchError, Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
class RouterService {
    #httpClient = inject(HttpClient);

    canActive(url: string): Observable<boolean> {
        let body = {
            route: url.substring(1)
        };
        return this.#httpClient.post<boolean>('user/allowed-access', JSON.stringify(body)).pipe(catchError(() => of(false)));
    }
}

export const ALLOW_ACCESS_ROUTE_GUARD: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routerService = inject(RouterService);

    const pathSegments = route.pathFromRoot
        .flatMap(snapshot => snapshot.url)
        .map(segment => segment.path);

    const paramCount = route.routeConfig?.path?.split('/').filter(p => p.startsWith(':')).length || 0;

    const cleanPath = pathSegments
        .filter((_, index) => index < pathSegments.length - paramCount)
        .join('/');

    const finalUrl = `/${cleanPath}`;

    return routerService.canActive(finalUrl);
}